/* ooakvogue Instant Multi-Currency Converter, Flying Cart Animation & Red Badge Updates */

const RATES = {
  USD: { symbol: '$', rate: 1.0, prefix: '$' },
  EUR: { symbol: '€', rate: 0.92, prefix: '€' },
  GBP: { symbol: '£', rate: 0.79, prefix: '£' },
  INR: { symbol: '₹', rate: 83.2, prefix: '₹' },
  CAD: { symbol: 'CA$', rate: 1.36, prefix: 'CA$' },
  AUD: { symbol: 'AU$', rate: 1.52, prefix: 'AU$' },
  AED: { symbol: 'AED ', rate: 3.67, prefix: 'AED ' }
};

function changeStoreCurrency(currencyCode) {
  if (!RATES[currencyCode]) return;

  localStorage.setItem('ooakvogue_currency', currencyCode);
  const info = RATES[currencyCode];

  // 1. Update all product price tags across the site
  document.querySelectorAll('.price-convertible').forEach(el => {
    const rawUsd = parseFloat(el.getAttribute('data-usd') || el.innerText.replace(/[^0-9.]/g, ''));
    if (!isNaN(rawUsd) && rawUsd > 0) {
      const converted = (rawUsd * info.rate).toFixed(2);
      if (currencyCode === 'INR') {
        el.innerText = `₹${Math.round(rawUsd * info.rate).toLocaleString('en-IN')}`;
      } else {
        el.innerText = `${info.prefix}${parseFloat(converted).toLocaleString()}`;
      }
    }
  });

  // 2. Update filter input placeholders
  document.querySelectorAll('.price-filter-min').forEach(el => {
    el.placeholder = `Min (${info.symbol.trim()})`;
  });
  document.querySelectorAll('.price-filter-max').forEach(el => {
    el.placeholder = `Max (${info.symbol.trim()})`;
  });

  // 3. Update active currency selector label
  const labelEl = document.getElementById('active-currency-label');
  if (labelEl) {
    labelEl.innerText = `${currencyCode} (${info.symbol.trim()})`;
  }
}

/* Subtle Cursor Move Background Parallax Effect (Non-Intrusive) */
document.addEventListener('mousemove', (e) => {
  const mouseX = (e.clientX / window.innerWidth - 0.5);
  const mouseY = (e.clientY / window.innerHeight - 0.5);

  const bg1 = document.querySelector('.p-bg-1');
  const bg2 = document.querySelector('.p-bg-2');
  const bg3 = document.querySelector('.p-bg-3');

  if (bg1) bg1.style.transform = `translate3d(${mouseX * 28}px, ${mouseY * 28}px, 0)`;
  if (bg2) bg2.style.transform = `translate3d(${mouseX * -38}px, ${mouseY * -38}px, 0)`;
  if (bg3) bg3.style.transform = `translate3d(${mouseX * 20}px, ${mouseY * 20}px, 0)`;
});

/* IntersectionObserver Smooth Scroll Reveal Animation */
function initScrollReveal() {
  const revealElements = document.querySelectorAll('.product-card, .brand-card, .vstore-hero-card, .vstore-section-title, .vstore-section-header');
  
  revealElements.forEach(el => el.classList.add('reveal-on-scroll'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  revealElements.forEach(el => observer.observe(el));
}

/* Flying Cart Item Micro-Animation & Red Badge Interceptor */
document.addEventListener('submit', function(e) {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;

  e.preventDefault();

  const btn = form.querySelector('button[type="submit"]');
  const card = form.closest('.product-card') || form.closest('.vstore-hero-card') || form;
  const img = card ? card.querySelector('img') : null;

  // 1. Calculate Flying Animation Positions
  const startRect = btn ? btn.getBoundingClientRect() : card.getBoundingClientRect();
  const targetCartBtn = document.querySelector('.cart-pill-btn') || document.getElementById('btn-cart-open');
  const endRect = targetCartBtn ? targetCartBtn.getBoundingClientRect() : { left: window.innerWidth - 60, top: 20, width: 40, height: 40 };

  // Create Flying Thumbnail Element
  const flyer = document.createElement(img && img.src ? 'img' : 'div');
  if (img && img.src) {
    flyer.src = img.src;
  } else {
    flyer.innerText = '🛍️';
    flyer.style.background = '#1E3A2B';
    flyer.style.display = 'flex';
    flyer.style.alignItems = 'center';
    flyer.style.justifyContent = 'center';
    flyer.style.color = '#fff';
  }
  flyer.className = 'flying-cart-item';
  flyer.style.left = `${startRect.left + startRect.width / 2 - 24}px`;
  flyer.style.top = `${startRect.top + startRect.height / 2 - 24}px`;
  document.body.appendChild(flyer);

  // Force Reflow
  void flyer.offsetWidth;

  // Trigger Dynamic Flight Path
  flyer.style.left = `${endRect.left + endRect.width / 2 - 24}px`;
  flyer.style.top = `${endRect.top + endRect.height / 2 - 24}px`;
  flyer.style.transform = 'scale(0.2) rotate(360deg)';
  flyer.style.opacity = '0.2';

  // Button Feedback Text
  if (btn) {
    const originalText = btn.innerHTML;
    btn.innerHTML = 'Added! ✓';
    btn.style.background = '#2D5A42';
    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.style.background = '';
    }, 1500);
  }

  // 2. Execute AJAX Add To Cart (No Page Redirect)
  const formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(res => res.json())
  .then(() => fetch('/cart.js'))
  .then(res => res.json())
  .then(cart => {
    setTimeout(() => {
      flyer.remove();

      // Update Header Text Counters
      const countEls = document.querySelectorAll('#cart-count, #cart-count-mobile');
      countEls.forEach(el => { if (el) el.textContent = cart.item_count; });

      // Add / Update Glowing Red Badge
      const cartBtns = document.querySelectorAll('.cart-pill-btn');
      cartBtns.forEach(cBtn => {
        let badge = cBtn.querySelector('.cart-red-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-red-badge';
          cBtn.appendChild(badge);
        }
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';

        // Trigger Shake Pulse Effect on Cart Icon
        cBtn.classList.remove('cart-shake-anim');
        void cBtn.offsetWidth;
        cBtn.classList.add('cart-shake-anim');
      });
    }, 600);
  })
  .catch(err => {
    console.error('AJAX Add to Cart Error:', err);
    flyer.remove();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const savedCurrency = localStorage.getItem('ooakvogue_currency') || 'USD';
  changeStoreCurrency(savedCurrency);
  initScrollReveal();

  // Initialize Red Cart Badge if Cart Already Has Items
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.item_count > 0) {
        const cartBtns = document.querySelectorAll('.cart-pill-btn');
        cartBtns.forEach(cBtn => {
          let badge = cBtn.querySelector('.cart-red-badge');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-red-badge';
            cBtn.appendChild(badge);
          }
          badge.textContent = cart.item_count;
          badge.style.display = 'flex';
        });
      }
    });
});

/* -----------------------------------------------------------------------
   Accessibility Fix: Set alt on Shopify video_tag auto-generated poster imgs
   Shopify's video_tag filter creates <img> inside <video> without alt text.
   We read the product title from the parent [data-product-alt] attribute.
   ----------------------------------------------------------------------- */
(function fixVideoPosters() {
  function applyAlt() {
    document.querySelectorAll('video.lazy-autoplay-video').forEach(function(video) {
      var poster = video.querySelector('img');
      if (poster && !poster.getAttribute('alt')) {
        var parent = video.closest('[data-product-alt]');
        poster.setAttribute('alt', parent ? parent.getAttribute('data-product-alt') : '');
      }
    });
  }
  // Run on DOMContentLoaded and again after Shopify section loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAlt);
  } else {
    applyAlt();
  }
  document.addEventListener('shopify:section:load', applyAlt);
})();

/* -----------------------------------------------------------------------
   Luxury Sneak-Peek Slider Helper Functions
   ----------------------------------------------------------------------- */
window.setSneakSlide = function(el, index, e) {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }
  var slider = el.closest('.og-sneak-slider');
  if (!slider) return;
  slider.setAttribute('data-active-index', index);
  var dots = slider.querySelectorAll('.og-sneak-dot');
  dots.forEach(function(dot, idx) {
    if (idx === index) {
      dot.classList.add('active');
    } else {
      dot.classList.remove('active');
    }
  });
};

window.nextSneakSlide = function(el, e) {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }
  var slider = el.closest('.og-sneak-slider');
  if (!slider) return;
  var current = parseInt(slider.getAttribute('data-active-index') || '0', 10);
  var next = current === 0 ? 1 : 0;
  var targetDot = slider.querySelectorAll('.og-sneak-dot')[next];
  if (targetDot) {
    window.setSneakSlide(targetDot, next, e);
  }
};

window.prevSneakSlide = function(el, e) {
  window.nextSneakSlide(el, e);
};

window.toggleSneakSlider = function(slider, e) {
  if (e && (e.target.closest('.og-sneak-btn') || e.target.closest('.og-sneak-dot'))) return;
  var current = parseInt(slider.getAttribute('data-active-index') || '0', 10);
  var next = current === 0 ? 1 : 0;
  var targetDot = slider.querySelectorAll('.og-sneak-dot')[next];
  if (targetDot) {
    window.setSneakSlide(targetDot, next, e);
  }
};

/* -----------------------------------------------------------------------
   Mobile header: only the logo/cart row stays stuck while scrolling.
   The search bar and category pills scroll away with the page, so a phone
   keeps ~100% of the screen for content instead of losing ~190px.
   The header wrapper and its container are flattened (display: contents) so
   the top row can stick against the whole page, not just its own header.
   ----------------------------------------------------------------------- */
(function compactMobileHeader() {
  var css = '@media (max-width: 768px) {' +
    '.vstore-header { position: static !important; display: contents !important; }' +
    '.vstore-header > .container { display: contents !important; }' +
    '.vstore-header .header-top-row { position: sticky; top: 0; z-index: 100; padding: 0.6rem 1.25rem; background: rgba(250, 247, 242, 0.97); -webkit-backdrop-filter: blur(10px); backdrop-filter: blur(10px); box-shadow: 0 2px 10px rgba(20, 26, 22, 0.06); }' +
    '.vstore-header .vstore-filter-row { padding: 0 1.25rem 0.75rem; margin-top: 0.5rem !important; border-bottom: 1px solid var(--color-border); }' +
    '}';
  var style = document.createElement('style');
  style.id = 'mobile-compact-header';
  style.textContent = css;
  document.head.appendChild(style);
})();